// extracted by mini-css-extract-plugin
module.exports = {"innerWindow":"_app_innerWindow__xRBp2","overlayStackingContext":"_app_overlayStackingContext__TJME8"};